import "core-js/modules/es6.object.freeze";
import { colors, colorsRefresh } from './colors';
import Color from 'color';
/**
 * NOTE:
 *  Shadow color values should not be standardized in colors.js
 *  This is because shadow darkness depends on the spread and blur as well.
 *  Shadow color values should be defined in this file,
 *  alongside the actual CSS rule that contains the offset, spread and blur values.
 *
 *  TODO for future: create a more robust shadow system. In the meantime,
 *  know that it is a wild wild west out there.
 */

var shadowValues = Object.freeze({
  "default": colors.shadow,
  spread: Color(colors.navy).fade(0.33).string()
});
export var shadows = Object.freeze({
  box: {
    none: 'none',
    "default": "0 2px 0 0 " + colors.shadow,
    spread: "0 2px 10px 0 " + colors.shadow
  },
  filter: {
    none: 'none',
    "default": "drop-shadow(0 2px 0 " + shadowValues["default"] + ")",
    spread: "drop-shadow(0 2px 10px " + shadowValues.spread + ")"
  }
});
export var shadowsRefresh = Object.freeze({
  box: {
    none: 'none',
    "default": "0 8px 24px " + colorsRefresh.shadow,
    spread: "0 8px 24px " + colorsRefresh.shadow
  },
  filter: {
    none: 'none',
    "default": "drop-shadow(0 2px 0 " + shadowValues["default"] + ")",
    spread: "drop-shadow(0 2px 10px " + shadowValues.spread + ")"
  }
});